import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import { employeesTipReport } from "./../../../action/arkiveActions";
import Home from "./../../Home";
import List from "./List";
import { setDefaultDates, setMonthDates } from "../../../helpers/commonDates";

const TipReport = (props) => {
  let [date, setDate] = useState(moment().date()._d);
  let [month, setMonth] = useState(moment().date()._d);
  let [isLoading, setIsLoading] = useState(false);
  let [dayType, setDayType] = useState("");
  let [employeeTipData, setEmployeeTipData] = useState([]);

  useEffect(() => {
    const fetchEmployeesTipReport = async (tSDay, tEDay) => {
      const data = {
        startDate: tSDay,
        endDate: tEDay,
      };

      await props.employeesTipReport(data).then(() => {
        setIsLoading(false);
      });
    };
    setIsLoading(true);
    if (dayType === "month") {
      const { tSDay, tEDay } = setMonthDates(month);
      fetchEmployeesTipReport(tSDay, tEDay);
    } else {
      const { tSDay, tEDay } = setDefaultDates(date);
      fetchEmployeesTipReport(tSDay, tEDay);
    }
  }, [date, month]);

  const handleDateChange = (date, type) => {
    setDate(date);
    setMonth(moment().date()._d);
    setDayType(type);
  };
  const handleMonthChange = (month, type) => {
    setDate(moment().date()._d);
    setMonth(month);
    setDayType(type);
  };

  return (
    <>
      <Home>
        <div className="report-container">
          <span className="item ">
            <span>Arkiv : </span> TIP RAPPORT
            <NavLink to="/arkiv" className="btn back-btn">
              <i className="fa fa-arrow-circle-left" aria-hidden="true" />
            </NavLink>
          </span>
        </div>
        <List
          dataSource={props.employeesTip}
          handleDateChange={handleDateChange}
          handleMonthChange={handleMonthChange}
        />
      </Home>
    </>
  );
};

const mapStateToProps = ({ employeesTip }) => {
  return { employeesTip };
};

export default connect(mapStateToProps, { employeesTipReport })(TipReport);
